"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CurrentMedia = void 0;
Object.defineProperty(exports, "Dragon", {
  enumerable: true,
  get: function get() {
    return _DragonVideo.Dragon;
  }
});
exports.Music = void 0;
exports.PdfDisplay = PdfDisplay;
Object.defineProperty(exports, "TimestampEditor", {
  enumerable: true,
  get: function get() {
    return _TimestampEditor.TimestampEditor;
  }
});
Object.defineProperty(exports, "Video", {
  enumerable: true,
  get: function get() {
    return _Video.Video;
  }
});

var _react = _interopRequireWildcard(require("react"));

var _firebase = require("../firebase");

require("./Media.scss");

var _Video = require("./Video");

var _DragonVideo = require("./DragonVideo");

var _TimestampEditor = require("./TimestampEditor");

var _primitives = require("@bedrock-layout/primitives");

var _util = require("../util");

var _DBResouceContext = require("./DBResouceContext");

var _JoSchmoWhat = _interopRequireDefault(require("../../assets/JoSchmoWhat.png"));

var _excluded = ["src", "thumbnail", "children", "absoluteChildren", "className"],
    _excluded2 = ["src", "metadata", "autoPlay", "repetitionCount"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

var CurrentMedia = function CurrentMedia(props) {
  var _seriesList$generator, _seriesList$generator2;

  var _useResourceContext = (0, _DBResouceContext.useResourceContext)(),
      query = _useResourceContext.query,
      allResources = _useResourceContext.allResources,
      modules = _useResourceContext.modules,
      seriesList = _useResourceContext.seriesList;

  var seriesData = seriesList === null || seriesList === void 0 ? void 0 : seriesList[query === null || query === void 0 ? void 0 : query.series];
  var video = allResources === null || allResources === void 0 ? void 0 : allResources[query === null || query === void 0 ? void 0 : query.id];
  var online = (0, _firebase.useOnlineStatus)();
  var downloadUrl = (0, _firebase.useDownloadUrl)(video === null || video === void 0 ? void 0 : video.location);
  var cacheKey = (0, _firebase.firestoreCacheKey)(video === null || video === void 0 ? void 0 : video.location);
  var url = online ? downloadUrl : cacheKey;
  var locations = (0, _react.useMemo)(function () {
    return (video === null || video === void 0 ? void 0 : video.referencedVideos) && Object.values(video.referencedVideos).map(function (v) {
      return v.location;
    });
  }, [video]);
  var downloadUrls = (0, _firebase.useDownloadUrls)(locations);
  var cacheKeys = locations === null || locations === void 0 ? void 0 : locations.map(_firebase.firestoreCacheKey);
  var urls = online ? downloadUrls : cacheKeys; // Add to the cache because <video> range requests won't fill cache
  // @Cleanup eventually want to combine range requests for the cache

  (0, _react.useEffect)( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
    var cache, match;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!(online && url && self.caches)) {
              _context.next = 8;
              break;
            }

            _context.next = 3;
            return caches.open("media");

          case 3:
            cache = _context.sent;
            _context.next = 6;
            return cache.match(cacheKey);

          case 6:
            match = _context.sent;

            if (!match) {
              fetch(url).then(function (response) {
                if (!response.ok) {
                  throw new TypeError("bad response status");
                }

                return cache.put(cacheKey, response);
              }).catch(function (e) {
                return console.error("cache add failed", e);
              });
            }

          case 8:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  })), [url, online]);
  var src = (seriesData === null || seriesData === void 0 ? void 0 : seriesData.format) === "generated" ? urls : url;
  var thumbnail = (0, _firebase.useDownloadUrl)(video === null || video === void 0 ? void 0 : video.thumbnail);
  if (!query || !(query.series || query.module || query.id)) return "";
  if (!video) return /*#__PURE__*/_react.default.createElement(_primitives.Center, {
    centerChildren: true,
    centerText: true
  }, "We havent uploaded this yet, maybe you can try another video, and come back again later.", /*#__PURE__*/_react.default.createElement("img", {
    src: _JoSchmoWhat.default,
    style: {
      height: "30vmin",
      maxHeight: "20rem"
    }
  }));

  switch (seriesData === null || seriesData === void 0 ? void 0 : seriesData.format) {
    case "generated":
      var generatorFormat = JSON.parse(seriesData.generatorFormat);
      if ((seriesList === null || seriesList === void 0 ? void 0 : (_seriesList$generator = seriesList[generatorFormat === null || generatorFormat === void 0 ? void 0 : generatorFormat.loop]) === null || _seriesList$generator === void 0 ? void 0 : _seriesList$generator.format) == "music") return /*#__PURE__*/_react.default.createElement(Music.Dragon, {
        src: src,
        thumbnail: thumbnail,
        metadata: video
      });else if ((seriesList === null || seriesList === void 0 ? void 0 : (_seriesList$generator2 = seriesList[generatorFormat === null || generatorFormat === void 0 ? void 0 : generatorFormat.loop]) === null || _seriesList$generator2 === void 0 ? void 0 : _seriesList$generator2.format) == "video") return /*#__PURE__*/_react.default.createElement(_DragonVideo.Dragon.Video, {
        src: src,
        thumbnail: thumbnail,
        metadata: video
      });
      return '';

    case "video":
      return /*#__PURE__*/_react.default.createElement(_Video.Video, {
        src: src,
        thumbnail: thumbnail
      });

    case "music":
      return /*#__PURE__*/_react.default.createElement(Music, {
        src: src,
        thumbnail: thumbnail
      });

    case "pdf":
      return /*#__PURE__*/_react.default.createElement(PdfDisplay, {
        src: src
      });

    default:
      return '';
  }
};

exports.CurrentMedia = CurrentMedia;

function PdfDisplay(props) {
  return /*#__PURE__*/_react.default.createElement(_primitives.Cover, {
    top: /*#__PURE__*/_react.default.createElement(_primitives.Inline, {
      align: "center",
      gutter: "sm",
      onClick: function onClick() {
        window.open(props.src, "_blank");
      }
    }, /*#__PURE__*/_react.default.createElement("i", {
      className: "fas fa-download"
    }), "Download")
  }, /*#__PURE__*/_react.default.createElement(_primitives.Frame, {
    ratio: [8, 11],
    position: "50% 50%",
    className: "pdfMedia"
  }, /*#__PURE__*/_react.default.createElement("iframe", {
    src: props.src
  })));
}

var Music = function Music(props) {
  var videoRef = (0, _react.useRef)();

  var progressState = _Video.Video.Progress.useState({
    videoRef: videoRef,
    src: props.src
  });

  return /*#__PURE__*/_react.default.createElement(Music.Container, _extends({
    ref: videoRef
  }, props), /*#__PURE__*/_react.default.createElement(_Video.Video.PlayButton, {
    autoPlay: props.autoPlay
  }), /*#__PURE__*/_react.default.createElement(_Video.Video.Progress.Text, progressState), /*#__PURE__*/_react.default.createElement(_Video.Video.Progress.Bar, progressState), /*#__PURE__*/_react.default.createElement(_Video.Video.Loop, null), /*#__PURE__*/_react.default.createElement(_Video.Video.Fullscreen, null), /*#__PURE__*/_react.default.createElement(_Video.Video.Download, null));
};

exports.Music = Music;
Music.Container = /*#__PURE__*/_react.default.forwardRef(function (_ref2, fwVideoRef) {
  var src = _ref2.src,
      thumbnail = _ref2.thumbnail,
      children = _ref2.children,
      absoluteChildren = _ref2.absoluteChildren,
      className = _ref2.className,
      props = _objectWithoutProperties(_ref2, _excluded);

  var videoRef = (0, _util.useForwardedRef)(fwVideoRef);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: 'mediaRoot ' + className
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "absoluteContainer musicContainer"
  }, /*#__PURE__*/_react.default.createElement("audio", _extends({
    ref: videoRef,
    src: src,
    controls: false,
    poster: thumbnail,
    playsInline: true
  }, props)), _react.default.Children.map(absoluteChildren, function (child) {
    return /*#__PURE__*/_react.default.cloneElement(child, {
      videoRef: videoRef,
      src: src
    });
  }), /*#__PURE__*/_react.default.createElement(_primitives.Inline, {
    className: "controlBar",
    gutter: "2%",
    align: "center"
  }, _react.default.Children.map(children, function (child) {
    return /*#__PURE__*/_react.default.cloneElement(child, {
      videoRef: videoRef,
      src: src
    });
  }))));
});

Music.Dragon = function (_ref3) {
  var src = _ref3.src,
      metadata = _ref3.metadata,
      autoPlay = _ref3.autoPlay,
      _ref3$repetitionCount = _ref3.repetitionCount,
      repetitionCount = _ref3$repetitionCount === void 0 ? 5 : _ref3$repetitionCount,
      props = _objectWithoutProperties(_ref3, _excluded2);

  src = Object.values(src)[0];
  var videoRef = (0, _react.useRef)();

  var dragonState = _DragonVideo.Dragon.useState({
    videoRef: videoRef,
    src: src,
    metadata: metadata,
    repetitionCount: repetitionCount
  });

  return /*#__PURE__*/_react.default.createElement(Music.Container, _extends({
    ref: videoRef
  }, _objectSpread({
    src: src,
    autoPlay: autoPlay
  }, props), {
    absoluteChildren: /*#__PURE__*/_react.default.createElement(_DragonVideo.Dragon.RepeatBadge, dragonState)
  }), /*#__PURE__*/_react.default.createElement(_Video.Video.PlayButton, {
    autoPlay: props.autoPlay
  }), /*#__PURE__*/_react.default.createElement(_DragonVideo.Dragon.TimeBar, dragonState), /*#__PURE__*/_react.default.createElement(_Video.Video.Loop, null), /*#__PURE__*/_react.default.createElement(_Video.Video.Fullscreen, null));
};